import { useNative } from 'app/contexts/NativeContext';
import { useEffect, useState } from 'react';
const useNativeVASTKeywords = () => {
  const {
    isNativeApp,
    platform,
    buildInfo
  } = useNative();
  const isAndroid = platform === 'android';
  const isIos = platform === 'ios';
  const iOSAppId = '942371609';
  const [nativeVASTKeywords, setNativeVASTKeywords] = useState({
    msid: isAndroid ? buildInfo === null || buildInfo === void 0 ? void 0 : buildInfo.packageName : isIos ? iOSAppId : '',
    an: 'FuPa',
    platform
  });
  useEffect(() => {
    setNativeVASTKeywords(prev => ({
      ...prev,
      msid: isAndroid ? buildInfo === null || buildInfo === void 0 ? void 0 : buildInfo.packageName : isIos ? iOSAppId : ''
    }));
  }, [buildInfo, isAndroid, isIos]);
  if (!isNativeApp) {
    return {};
  }
  return nativeVASTKeywords;
};
export default useNativeVASTKeywords;